import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable, signal, WritableSignal } from "@angular/core";
import { RechargeDto, RechargeResponse, TransactionInfo } from "@core/models";
import { WalletService } from "./wallet.service";
import { environment } from "@env/environment";
import { tap } from "rxjs";
import { IS_PUBLIC } from "@core/interceptors/auth.interceptor";

@Injectable()
export class PaymentService {
  private readonly http = inject(HttpClient);
  private readonly walletService = inject(WalletService);
  private readonly CONTEXT = {context: new HttpContext().set(IS_PUBLIC, true)};

  rechargeResponse: WritableSignal<RechargeResponse | null> = signal(null);
  transactionInfo: WritableSignal<TransactionInfo | null> = signal(null);

  rechargeAmount() {
    const dto: RechargeDto = {
      nep_Amount: Math.round((this.walletService.rechargeAmount() ?? 0) * 100),
      nep_Currency: 978,
      nep_UrlSuccess: `${window.location.host}/payment/success`,
      nep_UrlError: `${window.location.host}/payment/failed`,
      nep_UrlRefused: `${window.location.host}/payment/failed`,
      nep_UrlCancel: `${window.location.host}/payment/failed`,
    };

    return this.http.post(`${environment.apiURL}/payments/buy`, dto).pipe(
      tap((response: any) => this.rechargeResponse.set(response.data))
      // tap(() => this.rechargeResponse.set({
      //     "nep_Amount": 4000,
      //     "nep_Currency": 978,
      //     "nep_UrlSuccess": "aHR0cHM6Ly9sb2NhbGhvc3Qvc3VjY2Vzcw==",
      //     "nep_UrlError": "aHR0cHM6Ly9sb2NhbGhvc3QvZXJyb3I=",
      //     "nep_UrlRefused": "aHR0cHM6Ly9sb2NhbGhvc3QvZXJyb3I=",
      //     "nep_UrlCancel": "aHR0cHM6Ly9sb2NhbGhvc3QvZXJyb3I=",
      //     "nep_MerchantID": "Mjk2Xzk4MTQzMzEwOTM3Mw==",
      //     "nep_MerchantLabel": "R3Vlc3RVcA==",
      //     "nep_UrlStatus": "aHR0cHM6Ly93d3cudGltcG9sYWIuY29tL25wdGcucGhw",
      //     "nep_Mode": 2,
      //     "nep_TransactionID": "MTc0MjQ2NTc5NzM3Mjc0NA==",
      //     "nep_Sign": "2aQNGwnNz7zeTLq1hylX7-PZ76pQzR1zURv4hU61FN0=",
      //     "url_payment": "https://qualif.nepting.com/epay/payment"
      //   }))
    );
  }

  getTransactionInfo(transactionId: string) {
    return this.http.get(`${environment.apiURL}/transactions?t=${encodeURIComponent(transactionId)}`, this.CONTEXT).pipe(
      tap((response: any) => this.transactionInfo.set(response.data))
    );
  }
}
